var map = {
	"./icon-copy-paste.svg": "91e5",
	"./icon-csv-gray.svg": "3993",
	"./icon-csv.svg": "d570",
	"./icon-form-textbox-gray.svg": "4ddf",
	"./icon-form-textbox.svg": "9ea8",
	"./icon-pickup.svg": "048b",
	"./icon-spot.svg": "a261",
	"./icon-xml-gray.svg": "06bc",
	"./icon-xml.svg": "568b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c43";